import { Modal, message } from "antd";
import { identitySubscriptionService } from "services/subscriptions";

export const confirmDeletePlan = ({ plan, actorId, onDone }) => {
  if (!plan?.id) return;
  Modal.confirm({
    title: "Delete subscription plan?",
    content: `This will remove ${plan.name || plan.code || "the selected plan"}.`,
    okText: "Delete",
    okButtonProps: { danger: true },
    onOk: async () => {
      try {
        await identitySubscriptionService.plans.delete(plan.id);
        message.success("Subscription plan deleted");
        await onDone?.();
      } catch (err) {
        message.error(err?.message || "Failed to delete subscription plan");
      }
    },
  });
};

export const confirmCancelSubscription = ({ subscription, actorId, onDone }) => {
  if (!subscription?.id) return;
  Modal.confirm({
    title: "Cancel subscription?",
    content: "This will mark the subscription as cancelled.",
    okText: "Cancel subscription",
    okButtonProps: { danger: true },
    onOk: async () => {
      try {
        await identitySubscriptionService.subscriptions.cancel(subscription.id, actorId);
        message.success("Subscription cancelled");
        await onDone?.();
      } catch (err) {
        message.error(err?.message || "Failed to cancel subscription");
      }
    },
  });
};
